import React, {useEffect, useState} from 'react';
import {useUserContext} from '../../../../contexts/UserContext';
import {useDepartmentContext} from '../../../../contexts/DepartmentContext';
import {useHistory, useParams} from 'react-router-dom';
import Prompt from '../../../../components/prompt/prompt';
import {t} from 'react-switch-lang';
import {deleteFinding} from '../../../../services/findings';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {getRevisionTableColumnsDashboard} from '../../../revisions/const';
import roles from '../../../../utils/roles';
import FindingsFilter from './FindingsFilters';
import FindingsTable from '../../../revisions/components/table/FindingsTable';
import RecommendationCard from './RecommendationCard';

const FindingsCompleted = ({activeTab}) => {
  const [query, setQuery] = useState('');
  const [updateTable, setUpdateTable] = useState(0);
  const [allowCRUD, setAllowCRUD] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);
  const user = useUserContext();
  const departments = useDepartmentContext();
  const history = useHistory();
  const onFindingsDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteFinding'),
        text: t('question.deleteFinding'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteFinding(record?.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {
                  entity: t('revisions.finding'),
                }),
                icon: 'success',
              });
              resolve(response);
              // setUpdateTable((prevState) => !prevState);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError'),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const columns = getRevisionTableColumnsDashboard(
    history,
    onFindingsDelete,
    true,
    allowCRUD,
    allowEdit
  );

  const findingsFilter = (data) => {
    const parameters = [];

    if (data?.searchInput !== '') {
      parameters.push(`name.contains=${data?.searchInput}`);
    }
    if (data?.riskLevel?.value) {
      parameters.push(`riskLevel.equals=${data?.riskLevel?.value}`);
    }

    return parameters.join('&');
  };
  const filterSubmit = (data) => {
    const params = findingsFilter(data);
    setQuery(params);
    setUpdateTable((prevState)=>prevState+1);
  };

  const revisionRoles = [
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_super_admin,
    roles.role_admin
  ];
  const allowedRoles = [
    roles.role_super_admin,
    roles.role_admin
  ];

  useEffect(() => {
    const result = allowedRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowEdit(result.length > 0);
  }, [user]);
  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowCRUD(result.length > 0);
  }, [user]);

  return (
    <>
      <div className="mx-5">
        <FindingsFilter
          submit={filterSubmit}
          user={user}
          departments={departments}
        />
        < div style={{marginLeft: "-27px"}}>
        <FindingsTable
          key={updateTable}
          columns={columns}
          query={query}
          apiAddon={`findingStatus.equals=${activeTab}`}
          api={`/findings`}
          onClickRow={(findingId, revisionId) => {
            history.push(`/revisions/${revisionId}/findings/${findingId}`);
          }}
        />
          {/*<RecommendationCard activeTab={activeTab} />*/}
        </div>
      </div>
    </>
  );
};

export default FindingsCompleted;